import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CloseIcon from "assets/icons/close.svg?react";
import classNames from "classnames";
import ChooseTagNew from "components/ChooseTagNew";
import SearchDropdown from "components/SearchDropdown";
import SearchEntitiesNew from "components/SearchEntitiesNew";
import SelectChannel from "components/SelectChannel";
import SelectFlagNew from "components/SelectFlagNew";
import WideSearch from "components/WideSearch";
import { IEntity } from "dto/IEntity";
import { ITag } from "dto/ITag";
import { FC, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import styles from "./styles.module.scss";
import { ESearchTypes, Props } from "./typings";
import { ListType } from "dto/ListType";
import { getTagTypeForListType } from "utils/getTagTypeForListType";
import { useTranslation } from "react-i18next";

const SearchBar: FC<Props> = ({ isExpanded, onChange }) => {
  const { t } = useTranslation();
  const { filterId } = useParams();
  const [value, setValue] = useState("");
  const [showInput, setShowInput] = useState(false);
  const [showFocused, setShowFocused] = useState(false);

  const inputWrapper = useRef(null);

  const [statuses, setStatuses] = useState<null | any[]>(null);
  const [tags, setTags] = useState<null | ITag | undefined>(undefined);
  const [entity, setEntity] = useState<null | IEntity | undefined>(undefined);
  const [kind, setKind] = useState<null | number>(null);

  const isCases = window.location.href.search("cases") !== -1;
  const isClient = window.location.href.search("clients") !== -1;
  const isOutcoming = window.location.href.search("outcoming") !== -1;
  const isTasks = window.location.href.search("actions") !== -1;

  let listType: ListType = ListType.Incoming;

  if (isOutcoming) {
    listType = ListType.Outgoing;
  }

  if (isCases) {
    listType = ListType.Cases;
  }

  if (isClient) {
    listType = ListType.Participants;
  }

  if (isTasks) {
    listType = ListType.Tasks;
  }

  // useEffect(() => {
  //   // setValue("");
  //   setShowInput(false);
  // }, [location]);

  useEffect(() => {
    onChange(
      value,
      statuses?.[0]?.Id ?? null,
      tags?.Id ?? null,
      entity?.Id ?? null,
      kind ?? null
    );
  }, [value, statuses, tags, entity, kind]);

  useEffect(() => {
    setStatuses(null);
    setTags(undefined);
    onChange("", null, null, null, null);
  }, [filterId]);

  const handleChangeValue = (e: any) => {
    setValue(e.target.value);
    // onChange(e.target.value);
  };

  const ref = useRef(null);
  const refka = useRef(null);

  const outsideRef = useRef(null);

  const [showWide, setShowWide] = useState(false);

  const [showMenu, setShowMenu] = useState(false);

  // useOnClickOutside(outsideRef, () => {
  //   if (showInput && !showWide) {
  //     setShowInput(false);
  //     setEntity(undefined);
  //     setTags(undefined);
  //     setStatuses(null);
  //   }
  // });

  const handleChoose = (type: ESearchTypes) => {
    setShowMenu(false);
    switch (type) {
      case ESearchTypes.STATUS:
        if (!statuses?.length) {
          setStatuses([null]);
          return;
        }
        setStatuses([null]);
        return;
      case ESearchTypes.TAG:
        setTags(null);
        return;
      case ESearchTypes.SHARED:
        setEntity(null);
        return;
      case ESearchTypes.CHANNEL:
        setKind(-1);
        return;
    }
  };

  const showFilters =
    showInput &&
    (statuses?.[0] !== undefined ||
      tags !== undefined ||
      entity !== undefined ||
      kind !== null);

  return (
    <div
      ref={outsideRef}
      className={classNames(
        styles.ext,
        showWide && styles.wide,
        showFilters && styles.withFilters
      )}
    >
      <div
        onClick={() => {
          if (showInput) return;
          setShowInput(true);
          //@ts-ignore
          inputWrapper?.current?.focus?.();
        }}
        ref={ref}
        className={classNames(
          styles.wrapper,
          !showInput &&
            !value.length &&
            !showFocused &&
            !isExpanded &&
            styles.hide,
          showFilters && styles.withFilters,
          isExpanded && styles.fixed
        )}
      >
        <div className={styles.icon}>
          {/* {showInput && (
            <div className={styles.icons}>
              <FilterIcon
                ref={refka}
                onClick={() => {
                  setShowMenu(!showMenu);
                }}
                className={styles.i}
              />
            </div>
          )} */}
          {(!showInput || isExpanded) && <FontAwesomeIcon icon={faSearch} />}
        </div>
        <div className={styles.inputWrapper}>
          <input
            ref={inputWrapper}
            onFocus={() => {
              setShowFocused(true);
            }}
            onBlur={() => setShowFocused(false)}
            className={styles.input}
            value={value}
            onChange={handleChangeValue}
            placeholder={t("common.search")}
          />
        </div>
        {showInput && (
          <div className={styles.cleanIcon}>
            <CloseIcon
              onClick={() => {
                setValue("");
                onChange("", null, null, null, null);
                setShowInput(false);
              }}
            />
          </div>
        )}
      </div>
      {ref?.current && showWide && (
        <WideSearch toggle={() => setShowWide(false)} refWrapper={ref} />
      )}
      {showMenu && (
        <SearchDropdown
          toggle={() => setShowMenu(false)}
          onChoose={handleChoose}
          refWrapper={refka}
          listType={listType}
        />
      )}

      {showFilters && (
        <div className={styles.list}>
          {statuses?.map((s, index) => {
            return (
              <div className={styles.listBox}>
                <SelectFlagNew
                  listType={listType}
                  initOpen
                  selectedStatus={s}
                  onChoose={(s) => {
                    const newStatuses = [...statuses];
                    newStatuses[index] = s;
                    setStatuses(newStatuses);
                  }}
                  onClose={() => {
                    setStatuses(null);
                  }}
                />
              </div>
            );
          })}

          <div className={styles.listBox}>
            {tags !== undefined && (
              <ChooseTagNew
                label={tags?.Name ?? undefined}
                type={getTagTypeForListType(listType)}
                onChoose={(tag) => {
                  setTags(tag);
                }}
                size="small"
                disableBorder={true}
                variant="outlined"
                labelPosition="top"
                // onClose={() => {
                //   setTags(undefined);
                // }}
              />
            )}
          </div>
          <div className={styles.listBox}>
            {entity !== undefined && (
              <SearchEntitiesNew
                initOpen
                onClose={() => {
                  setEntity(undefined);
                }}
                label={entity ? entity.Label ?? entity.Name : t("statuses.shared")}
                onChoose={(entity) => {
                  setEntity(entity);
                }}
              />
            )}
          </div>
          <div className={styles.listBox}>
            {kind && (
              <SelectChannel
                onClose={() => {
                  setKind(null);
                }}
                selectedStatus={kind}
                onChoose={(kind) => {
                  setKind(kind);
                }}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchBar;
